import Footer from "./Footer"
import "./TodoList.css"

const TodoList = ({todos, deleteTodos,toggleCompleted,clearCompleted,setFilter, filter}) => {
    
    

  return (
    <div className="contents">
    <div>
        {
            todos.map((todo,index) => {
                return(
                    <ul 
                    className='list-container'
                    key={index}>
                        <li 
                        className={todo.completed? "completed" : ""}
                        onClick={()=>toggleCompleted(index)}>{todo.task}
                            <span onClick={() => deleteTodos(index)}></span>
                        </li>
                    </ul>
                )
            })
        }
    </div>
    <Footer 
    todos = {todos}
    clearCompleted={clearCompleted}
    setFilter={setFilter}
    filter={filter} />
    </div>
  )
}

export default TodoList